import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { BannerInitialStateType } from '../utils/Types';
import {
  bannerAddMedia,
  bannerGetAllList,
  bannerRemoveMedia,
  bannerUpdateOrder,
} from '../services';
import { isAPISuccess } from '../utils/Util';
import { API_STATUS } from '../utils/Constant';
const initialState: BannerInitialStateType = {
  allList: [],
  allListAPIStatus: '',
};

export const getBannerAllList = createAsyncThunk(
  'banner/getBannerAllList',
  async (params: any) => {
    const res = await bannerGetAllList(params);
    return res.data;
  }
);
export const addBannerMedia = createAsyncThunk(
  'banner/addBannerMedia',
  async (data: any) => {
    const res = await bannerAddMedia(data);
    return res.data;
  }
);
export const removeBannerMedia = createAsyncThunk(
  'banner/addBannerMedia',
  async (data: any) => {
    const res = await bannerRemoveMedia(data);
    return res.data;
  }
);

export const updateBannerOrder = createAsyncThunk(
  'banner/updateBannerOrder',
  async (data: any) => {
    const res = await bannerUpdateOrder(data);
    return res.data;
  }
);

export const bannerSlice = createSlice({
  name: 'banner',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getBannerAllList.pending, (state) => {
        state.allListAPIStatus = API_STATUS.LOADING;
      })
      .addCase(getBannerAllList.fulfilled, (state, action) => {
        if (isAPISuccess(action.payload)) {
          state.allListAPIStatus = API_STATUS.SUCCEEDED;
          state.allList = action.payload.result;
        } else {
          state.allListAPIStatus = API_STATUS.FAILED;
          state.allList = [];
        }
      });
  },
});

export const bannerSelector = (state: { banner: BannerInitialStateType }) =>
  state.banner;
export default bannerSlice.reducer;
